import { render, staticRenderFns } from "./DeptBaseInfo.vue?vue&type=template&id=20273a49&scoped=true&"
import script from "./DeptBaseInfo.vue?vue&type=script&lang=js&"
export * from "./DeptBaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./DeptBaseInfo.vue?vue&type=style&index=0&id=20273a49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20273a49",
  null
  
)

export default component.exports